b64Decode = require('js-base64').Base64.decode

settings  = document.getElementById('site-settings').innerText
settings  = settings.replace(/\s|\n/g, '')
settings  = b64Decode(settings)
settings  = JSON.parse(settings)

module.exports = settings


// WEBPACK FOOTER //
// ./assets/js/shared/util/site_settings.coffee